var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"living-options-dwellings"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"dwellings"},[_c('h3',[_vm._v("Dwellings")]),_c('button',{staticClass:"btn btn-sm btn-primary mb-4",on:{"click":_vm.addDwelling}},[_vm._v("Add Dwelling")]),_c('div',{staticClass:"mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dwellingFilterText),expression:"dwellingFilterText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Filter dwellings"},domProps:{"value":(_vm.dwellingFilterText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dwellingFilterText=$event.target.value}}})]),_c('v-table',{attrs:{"columns":[
            { 
              label: 'Label',
              field: 'label'
            },
            { 
              label: 'Builder',
              field: 'builderLabel',
              options: {
                sortable: true,
                return: function (fieldValue) {
                  return fieldValue
                }
              }
            },
            { 
              label: 'Attached to Lots', 
              field: 'associatedLots', 
              options: {
                sortable: false,
                return: function (fieldValue) {
                  if (fieldValue === 'Not Found') {
                    return '-'
                  } else {
                    return fieldValue.map(function (field) { return ("<div>" + (field.label) + "</div>"); }).join('')
                  }
                },
              }
            } ],"rows":_vm.filteredDwellings,"show-active-toggle":_vm.activeUser.access.indexOf('live-toggle') !== -1,"save-action":"SAVE_DWELLING"},on:{"edit":function($event){return _vm.editDwelling($event._id)},"clone":function($event){return _vm.cloneDwelling($event)},"delete":function($event){return _vm.deleteDwelling($event._id)}}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }